<template>
  <div class="p-4 bg-white border border-gray-200 rounded shadow-sm">
    <div
      v-if="!loading && client"
      class="flex space-x-4"
    >
      <div class="flex items-center justify-center w-20 h-20 p-4 text-4xl text-white bg-gray-400 rounded-full">
        {{ nameIcon }}
      </div>
      <div class="block h-full space-y-2 break-all">
        <div class="text-base font-medium">{{ client.name }}</div>
        <div class="text-sm text-gray-400">Email: {{ client.email }}</div>
        <div class="text-sm text-gray-400">Documento: {{ document }}</div>
      </div>
    </div>
    <div v-show="loading">
      <ExternalLoading
        text="Carregando informações do cliente"
        py="0"
      />
    </div>
  </div>
</template>

<script>
import { nameIcon, formatDocument } from '@/utils/utils'
import ExternalLoading from '@/components/commons/ExternalLoading'

export default {
  name: 'ExternalClientInfo',

  props: {
    client: Object,
    loading: Boolean
  },

  components: {
    ExternalLoading
  },

  computed: {
    nameIcon () {
      const { name = '' } = this.client
      return nameIcon(name)
    },

    document () {
      const { document = '' } = this.client
      return formatDocument(document)
    }
  }
}
</script>
